import Entity from "@/services/westore/entities/entity";

export class Freight extends Entity {
  static uri = "/freights";

  static store(payloadRequest) {
    return super.create(Freight.uri, payloadRequest);
  }

  static getOne(id, params = {}) {
    return super.get(Freight.uri, id, params);
  }

  static getAll(params = {}) {
    return super.getAll(Freight.uri, params);
  }

  static filter(params = {}) {
    return super.getAll(`${Freight.uri}`, params);
  }

  static getInsights() {  
    return super.get(`${Freight.uri}/insights`);
  }
}

